<template>
  <div class="search-wrapper">
    <div class="custom-container">
      <div class="d-lg-none">
        <MobileFilters />
      </div>
      <div class="page-header-wrapper">
        <div v-if="isMobile && isBookmarksShown" class="mobileBookmarksHeader">
          <button class="arrowBack" @click="backToAllTrainers">
            <i class="el-icon-back fz-22" />
          </button>
          <div class="info">
            <p class="fz-16">
              {{ $t('common.bookmarks') }}
            </p>
            <p class="fz-12 mt-2">
              {{ $t('common.trainers') }}: {{ bookmarksNumber }}
            </p>
          </div>
        </div>
        <div v-else class="page-header">
          <h1 class="general-title">
            {{ responseHeader }}
          </h1>
          <p class="d-lg-none total-trainers-number">
            <span v-if="totalTrainersNumber">{{ $t('common.ammount') }}: </span
            >{{ totalTrainersNumber }}
          </p>
        </div>
      </div>
      <div class="d-flex search-content">
        <div id="filtersColumn" class="left-column d-none d-lg-block">
          <Search />
          <Filters class="mt-3" />
          <Bookmarks class="mt-3" view="button primary-button" />
        </div>
        <div id="mainSearchContent" class="main-content">
          <div class="d-none d-lg-flex top-search-controls">
            <SortMethods />
            <MapButton />
          </div>
          <div class="d-flex d-lg-none mobileSortAndBookmarks">
            <SortMethods />
            <Bookmarks class="restrictedBookmarksWidth" />
          </div>
          <TrainersList />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import Search from '@/components/Search/Search'
import Filters from '@/components/Search/FiltersBlock'
import Bookmarks from '@/components/Search/Bookmarks'
import TrainersList from '@/components/Search/TrainersList'
import MapButton from '@/components/Search/Map/MapButton'
import MobileFilters from '@/components/Search/MobileFilters'
import watchScreenWidth from '@/dependencies/mixins/watch-screen-width'
import MetaHeadMixin from '@/dependencies/mixins/meta-head'
import SortMethods from '@/components/Search/SortMethods'
import QueryUrlMixin from '@/dependencies/mixins/parse-make-query-url'

export default {
  name: 'SearchPage',
  components: {
    Search,
    Filters,
    Bookmarks,
    TrainersList,
    MapButton,
    MobileFilters,
    SortMethods
  },
  mixins: [watchScreenWidth, MetaHeadMixin, QueryUrlMixin],
  computed: {
    ...mapGetters({
      bookmarksNumber: 'search/getBookmarksNumber',
      responseHeader: 'search/getSeo',
      totalTrainersNumber: 'search/getTotal',
      isMobile: 'common/getWidth',
      isBookmarksShown: 'search/isBookmarksShown',
      metaTitle: 'seo/getTitle',
      metaContent: 'seo/getMeta'
    })
  },
  async mounted() {
    await this.changeFiltersStatus(false)
  },
  methods: {
    ...mapActions({
      showBookmarksList: 'search/SHOW_BOOKMARKS',
      changeFiltersStatus: 'search/SET_RESET_FILTERS_STATUS',
      cacheTrainers: 'search/CACHE_TRAINERS',
      clearFilters: 'search/CLEAR_FILTERS'
    }),
    async backToAllTrainers() {
      await this.showBookmarksList(false)
    }
  }
}
</script>

<style scoped lang="scss">
@import '~@/assets/css/variables';

.search-wrapper {
  min-height: 100vh;
  background-color: $bg;
}
.page-header {
  color: $gray;
  padding: 12px;
  .total-trainers-number {
    margin-top: 9px;
    font-size: 13px;
    min-height: 14px;
  }
  .general-title {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    font-size: 16px;
  }
}
.top-search-controls {
  align-items: center;
  justify-content: space-between;
}

.left-column {
  min-width: 285px;
  max-width: 285px;
  div {
    box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
  }
}
.main-content {
  flex: 1;
}
.mobileSortAndBookmarks {
  justify-content: space-between;
  padding: 12px;
  background-color: white;
  border-bottom: 1px solid $border-gray;
}
.restrictedBookmarksWidth {
  max-width: max-content;
  button {
    font-weight: normal;
  }
}
.mobileBookmarksHeader {
  display: flex;
  align-items: stretch;
  background-color: $primary;
  color: white;
  .info {
    padding: 12px;
  }
  .arrowBack {
    display: flex;
    align-items: center;
    padding: 12px 12px 12px 10px;
    color: #000;
    background-color: $dark-primary;
  }
}

@media (min-width: 992px) {
  .search-wrapper {
    padding-bottom: 50px;
  }
  .page-header {
    min-height: 40px;
    padding: 12px 30px;
    .general-title {
      font-size: 14px;
    }
  }
}
</style>
